/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppModelsCaptureScaleChannelReading
 */
export interface AppModelsCaptureScaleChannelReading {
    [key: string]: any | any;
    /**
     * 
     */
    rawValue: number;
    /**
     * 
     */
    signedValue: number;
    /**
     * 
     */
    netValue: number;
    /**
     * 
     */
    weightGrams: number;
    /**
     * 
     */
    calibrationSlope?: number | null;
    /**
     * 
     */
    calibrationXIntercept?: number | null;
}

/**
 * Check if a given object implements the AppModelsCaptureScaleChannelReading interface.
 */
export function instanceOfAppModelsCaptureScaleChannelReading(value: object): value is AppModelsCaptureScaleChannelReading {
    if ((!('rawValue' in (value as Record<string, any>)) && !('raw_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['rawValue'] === undefined && (value as Record<string, any>)['raw_value'] === undefined)) return false;
    if ((!('signedValue' in (value as Record<string, any>)) && !('signed_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['signedValue'] === undefined && (value as Record<string, any>)['signed_value'] === undefined)) return false;
    if ((!('netValue' in (value as Record<string, any>)) && !('net_value' in (value as Record<string, any>))) || ((value as Record<string, any>)['netValue'] === undefined && (value as Record<string, any>)['net_value'] === undefined)) return false;
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    return true;
}

export function AppModelsCaptureScaleChannelReadingFromJSON(json: any): AppModelsCaptureScaleChannelReading {
    return AppModelsCaptureScaleChannelReadingFromJSONTyped(json, false);
}

export function AppModelsCaptureScaleChannelReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppModelsCaptureScaleChannelReading {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'rawValue': json['raw_value'],
        'signedValue': json['signed_value'],
        'netValue': json['net_value'],
        'weightGrams': json['weight_grams'],
        'calibrationSlope': json['calibration_slope'] === undefined ? undefined : json['calibration_slope'] === null ? null : json['calibration_slope'],
        'calibrationXIntercept': json['calibration_x_intercept'] === undefined ? undefined : json['calibration_x_intercept'] === null ? null : json['calibration_x_intercept'],
    };
}

export function AppModelsCaptureScaleChannelReadingToJSON(json: any): AppModelsCaptureScaleChannelReading {
    return AppModelsCaptureScaleChannelReadingToJSONTyped(json, false);
}

export function AppModelsCaptureScaleChannelReadingToJSONTyped(value?: AppModelsCaptureScaleChannelReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'raw_value': value['rawValue'],
        'signed_value': value['signedValue'],
        'net_value': value['netValue'],
        'weight_grams': value['weightGrams'],
        'calibration_slope': value['calibrationSlope'],
        'calibration_x_intercept': value['calibrationXIntercept'],
    };
}

